export const buildSuccessData = (result) => ({
    success: true,
    keyBucketImage: '',
    keyBucketVideo: '',
    data: {
        score: result.score,
        quality: result.quality,
        isAlive: result.isAlive,
        isFraud: result.isFraud,
        probability: result.probability,
        threshold_probabillity: result.thresholdProbability,
        threshold_quality: result.thresholdQuality
    },
    videoBase64: '',
    photoBase64: result.imageUrl || '',
    videoBlob: {}
});

export const mapChallenges = (challenges) => {
    if (!challenges) return undefined;
    if (Array.isArray(challenges)) return challenges;
    return Object.entries(challenges)
        .filter(([, enabled]) => enabled)
        .map(([name]) => name);
};
